import T from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Icon } from '@acast/decibel';

const Container = styled.div`
  background-color: ${({ background }) => background};
  border-radius: 4px;
  color: ${({ foreground }) => foreground};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
`;

const CardIcon = ({ background, foreground, glyph }) => (
  <Container background={background} foreground={foreground}>
    <Icon glyph={glyph} />
  </Container>
);

CardIcon.propTypes = {
  background: T.string.isRequired,
  foreground: T.string.isRequired,
  glyph: T.node.isRequired,
};

export default CardIcon;
